
import { defineComponent, PropType } from 'vue'
import { iKpi, iKpiListItem } from '../KpiDocumentDesigner'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'
import KpiDocumentDesignerKpiListCardDescriptor from './KpiDocumentDesignerKpiListCardDescriptor.json'
import KpiDocumentDesignerKpiSelectDialog from './KpiDocumentDesignerKpiSelectDialog.vue'
import deepcopy from 'deepcopy'

export default defineComponent({
    name: 'kpi-edit-kpi-list-card',
    components: { Card, Column, DataTable, Dropdown, KpiDocumentDesignerKpiSelectDialog },
    props: { propData: { type: Object }, kpiList: { type: Array as PropType<iKpi[]> }, documentType: { type: String } },
    data() {
        return {
            KpiDocumentDesignerKpiListCardDescriptor,
            data: { kpi: [] } as { kpi: iKpiListItem[] },
            filters: { global: [filterDefault] } as Object,
            addKpiAssociationVisible: false,
            showSaveAsColumn: false
        }
    },
    watch: {
        propData() {
            this.loadData()
        },
        documentType() {
            this.setShowSaveAsColumn()
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.data = { kpi: [] }
            if (!this.propData) return
            this.data = Array.isArray(this.propData.kpi) ? (this.propData as { kpi: iKpiListItem[] }) : { kpi: [this.propData.kpi] }
            this.setShowSaveAsColumn()
        },
        setShowSaveAsColumn() {
            this.showSaveAsColumn = this.documentType === 'widget'
        },
        onKpiSelected(selectedKpi: iKpi[]) {
            const temp = deepcopy(this.data.kpi) as any[]
            this.data.kpi = []
            selectedKpi.forEach((kpi: iKpi) => {
                const index = temp.findIndex((tempKpi: iKpi) => tempKpi.name === kpi.name)
                if (index !== -1) {
                    this.data.kpi.push(temp[index])
                } else {
                    this.data.kpi.push({
                        isSuffix: 'false',
                        name: kpi.name,
                        prefixSuffixValue: '',
                        rangeMaxValue: '',
                        rangeMinValue: '',
                        vieweas: 'Speedometer',
                        category: kpi.category ? kpi.category.valueName : ''
                    })
                }
            })
            this.addKpiAssociationVisible = false
        },
        deleteKpiAssociationConfirm(kpi: iKpiListItem) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.deleteKpiAssociation(kpi)
                }
            })
        },
        deleteKpiAssociation(kpi: iKpiListItem) {
            const index = this.data.kpi.findIndex((tempKpi: iKpiListItem) => tempKpi.name === kpi.name)
            if (index !== -1) this.data.kpi.splice(index, 1)
        }
    }
})
